export default __webpack_public_path__ + "static/media/planeacion-logo.287273b8.png";